import API from "../../..";
import { useQueryWrapper } from "../../wrappers";
import { getRoomsByUserIdKey } from "../room-query-keys";

export function useQueryGetRoomsByUserId(userId: string, enabled = true) {
  const { isLoading, data, isError } = useQueryWrapper({
    queryKey: getRoomsByUserIdKey(userId),
    queryFn: () => API.Rooms.getRoomsByUserId(userId),
    enabled: enabled && !!userId,
  });

  return {
    isLoading,
    rooms: data || [],
    isError,
  };
}
